import React from "react";
import { Card } from "react-bootstrap";
import { FaCubes, FaCode, FaBoxes } from "react-icons/fa";
import { TbFiles } from "react-icons/tb";

const StatCards = ({ summary, title }) => {
  const stats = [
    {
      title: "Total lines of code",
      value: summary?.totalLOC ?? 0,
      icon: <FaCode size={30} />,
      color: "#6366f1",
      change: "+12%",
      changeType: "positive"
    },
    {
      title: "Total packages",
      value: summary?.totalPackages ?? 0,
      icon: <TbFiles size={30} />,
      color: "#10b981",
      change: "+5%",
      changeType: "positive"
    },
    {
      title: "Total modules/files",
      value: summary?.totalModules > 0
        ? summary.totalModules
        : summary?.totalFiles > 0
          ? summary.totalFiles
          : (summary?.totalClasses ?? 0),
      icon: <FaBoxes size={30} />,
      color: "#f59e0b",
      change: "0%",
      changeType: "neutral"
    },
    {
      title: "Total classes",
      value: summary?.totalClasses ?? 0,
      icon: <FaCubes size={30} />,
      color: "#ef4444",
      change: "-2%",
      changeType: "negative"
    },
  ];

  const formatNumber = (num) => {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'k';
    }
    return num.toString();
  };

  return (
    <div className="card p-4 shadow-sm" style={{ "height": "440px" }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">{title}</h5>

      </div>

      <div className="row g-3" style={{ "position": "relative", "top": "20px" }}>
        {stats.map((stat, index) => (
          <div className="col-lg-6 col-md-6 col-sm-12" key={index} data-aos="flip-left">
            <Card className="shadow-sm h-100 border-0 position-relative overflow-hidden">
              {/* Gradient accent bar */}
              <div
                className="position-absolute top-0 start-0 w-100"
                style={{
                  height: '4px',
                  background: `linear-gradient(90deg, ${stat.color}, ${stat.color}80)`
                }}
              />

              <Card.Body className="">
                <div className="d-flex align-items-center card-body justify-content-between mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: `${stat.color}15`,
                      width: '60px',
                      height: '60px',
                      color: stat.color,
                    }}
                  >
                    {stat.icon}
                  </div>
                  <div className="text-end">
                    <h2 className="fw-bold mb-1 stat-value" style={{ color: '#1f2937' }}>
                      {formatNumber(stat.value)}
                    </h2>
                    <p className="text-muted mb-0 small fw-medium">{stat.title}</p>
                  </div>
                </div>
              </Card.Body>

              {/* Subtle background pattern */}
              <div
                className="position-absolute bottom-0 end-0 opacity-10"
                style={{
                  width: '80px',
                  height: '80px',
                  background: `radial-gradient(circle, ${stat.color}20 0%, transparent 70%)`
                }}
              />
            </Card>
          </div>
        ))}
      </div>


    </div>
  );
};

export default StatCards;